exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#app[data-v-dc32f61e] {\n  overflow: hidden;\n  background-color: #850000;\n  font-size: 0;\n}\n#app .secondWrap[data-v-dc32f61e] {\n  margin: 0.8rem;\n  padding: 0.53rem;\n  background: rgba(255,138,93,0.18);\n  border-radius: 0.53rem;\n  border: 0.05rem solid rgba(251,173,99,0.38);\n}\n", ""]);

